import { createAction } from '@reduxjs/toolkit';

import type { NotificationsTypes } from '@modules';
import { createActions } from '@modules/helpers';

export const actions = createActions('notifications', {
  add: name => createAction<Omit<NotificationsTypes.NotificationType, 'id'>>(name),

  remove: name => createAction<string>(name),

  clear: name => createAction(name),
});

export default { ...actions };
